'use client'
import React, {useContext} from "react"
import Image from "next/image"
import Marquee from "react-fast-marquee"
import { GLOBAL_PATHS } from "@/lib/globals"
import { GlassBox } from "@/ui/components/custom/box"
import { TranslationContext } from "@/configs/context"
import {Box, Stack, useMediaQuery, useTheme} from "@mui/material"


/**
 * Ce composant permet d'afficher et d'organiser les informations d'un utilisateur
 * @name PartnersCarousel
 * @constructor
 */
const PartnersCarousel: React.FC = () => {
  const theme = useTheme()
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)

  const imageSize = 8*6
  const projects = [
    {
      title: "STD S.A.",
      img: `${GLOBAL_PATHS.PARTNERS}std.webp`,
      textColor: "rgba(105, 171, 197, 1)",
      backgroundColor: "rgba(105, 171, 197, 0.6)",
      width: imageSize,
      height: imageSize,
    },
    {
      title: "One Health",
      img: `${GLOBAL_PATHS.PARTNERS}One Health Data Graphic.png`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: 8*7,
      height: imageSize,
    },
    // {
    //   title: "LeCartel",
    //   img: `${GLOBAL_PATHS.PARTNERS}cartel-logo-v-white.webp`,
    //   textColor: "rgba(152, 215, 134, 1)",
    //   backgroundColor: "rgba(152, 215, 134, 0.6)",
    //   width: 8*9,
    //   height: imageSize,
    // },
    {
      title: "DGSN",
      img: `${GLOBAL_PATHS.PARTNERS}logo-dgsn.png`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: imageSize,
      height: imageSize,
    },
    {
      title: "Picardi Mall",
      img: `${GLOBAL_PATHS.PARTNERS}picardi-mall-logo-removebg-preview.png`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: imageSize,
      height: imageSize,
    },
    {
      title: "Alae Group",
      img: `${GLOBAL_PATHS.PARTNERS}logo_alae_group_transp-removebg-preview.png`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: 8*12,
      height: imageSize,
    },
    {
      title: "Douanes Camerounaises",
      img: `${GLOBAL_PATHS.PARTNERS}douane-300x300.png`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: imageSize,
      height: imageSize,
    },
    {
      title: "Douanes Camerounaises",
      img: `${GLOBAL_PATHS.PUBLIC}sarki-ai-logo-dark.svg`,
      textColor: "rgba(152, 215, 134, 1)",
      backgroundColor: "rgba(152, 215, 134, 0.6)",
      width: imageSize,
      height: imageSize,
    },
  ]

  return (
    <React.Suspense fallback={<div />}>
      <Box
        id="project-section"
        sx={{
          pb: { xs: 6, md: 1 },
          color: "common.white",
          px: { xs: 0.8, lg: 1 },
      }}
      >
        {/*<Typography
          variant={matchMd ? "h4" : "h5"}
          sx={{textAlign: "center", marginBottom: "2rem"}}
        >
          {t('translation:projects.title')}
        </Typography>*/}
        <Marquee speed={75} pauseOnHover>
          {projects.map((_, index) => (
            <Box
              key={index}
              sx={{
                mr: 3,
                px: { xs: 2, md: 4 },
                py: { xs: 2, md: 1 },
                // backgroundColor: _.backgroundColor
              }}
            >
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Image
                  alt=""
                  src={_.img}
                  width={_.width}
                  height={_.height}
                />
              </Stack>
            </Box>
          ))}
        </Marquee>
      </Box>
    </React.Suspense>
  )
}

export default PartnersCarousel
